import {
  ADD_CHARGER_IDS,
  CHARGER_SELECTED,
  RESET_CHARGER,
  RESET_CHARGER_FILTER,
  UPDATE_CHARGER_DATA,
  UPDATE_CHARGER_FILTER,
  UPDATE_FILTER_PARAM,
  UPDATE_FILTER_STATUS,
} from "./actionTypes";

const INIT_STATE = {
  selectedChargerId: "",
  chargerIds: [],
  chargerFilter: { param: { connectors: [], rating: [], Type: [], Location: [] }, status: "All" },
};

const ChargerManagement = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHARGER_SELECTED:
      if (action.payload.chargerId === null) return state;

      return {
        ...state,
        selectedChargerId: action.payload,
      };

    case UPDATE_CHARGER_DATA:
      return {
        ...state,
        chargerData: action.payload,
      };

    case ADD_CHARGER_IDS:
      return {
        ...state,
        chargerIds: action.payload,
      };

    case RESET_CHARGER:
      return {
        selectedChargerId: "",
        chargerIds: [],
        chargerFilter: { param: { connectors: [], rating: [], Type: [], Location: [] }, status: "All" },
      };

    case UPDATE_CHARGER_FILTER:
      return {
        ...state,
        chargerFilter: action.payload,
      };

    case UPDATE_FILTER_PARAM:
      return {
        ...state,
        chargerFilter: { ...state.chargerFilter, param: { ...action.payload } },
      };

    case UPDATE_FILTER_STATUS:
      return {
        ...state,
        chargerFilter: { ...state.chargerFilter, status: action.payload },
      };

    case RESET_CHARGER_FILTER:
      return {
        ...state,
        chargerFilter: { param: { connectors: [], rating: [], Type: [], Location: [] }, status: "All" },
      };
    default:
      return state;
  }
};

export default ChargerManagement;

export const getChargerState = (state) => state?.ChargerManagement?.chargerData;
